import { Cta } from "@/utils/Cta"

const BlogCta = (props: {children?: string, className?: string}) => {
  return (
    <div className="border-y-2 rounded-lg mt-5 py-0 border-dashed border-slate-300 italic text-sm">
      <p>
        Psst... Dessert Data connects all your marketing data into a neatly organized database.  You can use
        the same query to pull spend for Bing, TikTok, or Google.
      </p>
      <p className="mb-5">
        Don't worry about APIs changes or database uptime.  We handle all that for you.
      </p>
      <Cta className="mt-4 h-12 bg-blue-400 leading-5 pt-3 font-bold max-w-xs">
        GET STARTED FREE
      </Cta>
    </div>
  )
}

export default BlogCta